import type React from 'react';

import { useSearchParams } from 'react-router';

import type { HNVelgBehandlingsstedFrontend } from '../types/Resources';

import VentetiderForBehandlingComponent from './ventetider-for-behandling-component';
import { useResources } from '../resources';
import { useGetVentetiderForBehandlingQuery } from '../store/api/velgBehandlingsstedApi';
import { HN_VELG_BEHANDLINGSSTED_FRONTEND } from '../utils/resources-project';

const VentetiderForBehandlingContainer: React.FunctionComponent = () => {
  const [searchparams] = useSearchParams();
  const bid = searchparams.get('bid') ?? '';

  const resources = useResources<HNVelgBehandlingsstedFrontend>(HN_VELG_BEHANDLINGSSTED_FRONTEND);

  const bidIsValid = !!parseInt(bid);
  const shouldSkipQuery = !resources || !bidIsValid;

  const { data, isLoading, isError } = useGetVentetiderForBehandlingQuery(bid, {
    skip: shouldSkipQuery,
  });

  const error = !bidIsValid || isError ? `${resources?.tekniskFeilVentetiderForBehandling} ${bid}` : undefined;

  return (
    resources && (
      <VentetiderForBehandlingComponent
        resources={resources}
        loading={isLoading}
        error={error}
        ventetiderForBehandlingByBid={data?.ventetiderForBehandling}
      />
    )
  );
};

export default VentetiderForBehandlingContainer;
